import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { FormAssignmentsComponent } from '../form-assignments/form-assignments.component';

@Component({
    selector: 'app-org-form-assignments',
    standalone: true,
    imports: [...COMMON_IMPORTS, FormAssignmentsComponent],
    templateUrl: './org-form-assignments.component.html',
    styleUrl: './org-form-assignments.component.css',
})
export class OrgFormAssignmentsComponent {
    public orgId!: string;

    constructor(private readonly router: ActivatedRoute) {
        this.orgId = this.router.snapshot.paramMap.get("orgId")!;
    }
}
